import { render, staticRenderFns } from "./TrainingManagement.vue?vue&type=template&id=0baad5d2&"
import script from "./TrainingManagement.vue?vue&type=script&lang=js&"
export * from "./TrainingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports